






















import {
    Component,
    Prop,
    Vue,
    Watch,
    Mixins,
    Emit,
} from 'vue-property-decorator';
//@ts-ignore
import VueHistogramSlider from 'vue-histogram-slider';
import 'vue-histogram-slider/dist/histogram-slider.css';

@Component({
    components: { VueHistogramSlider }
})
export default class HistogramSlider extends Vue {

    /**
     * Chart data
     */
    @Prop({ type: Array, default: ()=>([]) })
    public chartData!: any[];

    /**
     * Chart data
     */
    @Prop({ type: Array, default: ()=>([]) })
    public labels!: any[];

    /**
     * Reset chart
     */
    @Prop({ type: Boolean, default: false })
    public resetChart!: boolean;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: String, default: 'Factor' })
    public name!: any;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Object })
    public chartOptions!: any;
    
    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 200})
    public height!: number;

    /**
     * ApexCharts data
     */
    private options: any = {};
    private series: any[] = [];
    private increment: number = 0;
    private barHeight: number = 0;
    private min: number = 0;
    private max: number = 0;

    get dataLength(): number {
        return this.chartData.length;
    }

    /**
     * initialize
     */
    mounted() {
    }

    beforeDestroy() {
        this.increment = 0;
    }

    /**
     * Watching for changes to the chartData property
     */
    @Watch('chartData', {deep: true})
    onChangeChartData() {
        // this.chartData.sort(function(a, b) {
        //     return a - b;
        // });
        // this.min = this.chartData[0];
        // this.max = this.chartData[this.chartData.length - 1];
        let data: any[] = [...this.chartData].sort(function(a: number, b: number) {
            return a - b;
        });
        this.min = data[0];
        this.max = data[data.length - 1];
        this.series = [{
            name: this.name,
            data: data
        }];
         if (!this.chartOptions) {
            this.applyDefaultOptions();
        } else {
            this.options = this.chartOptions;
        }
        this.barHeight = 50;
        this.increment++;
    }


    /**
     * Default Options
     */
    private applyDefaultOptions() {
        this.options = {
            chart: {
                height: 100,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        position: 'center', // top, center, bottom
                    },
                    endingShape: 'rounded',
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (val: any) {
                    return String(val ? val : '');
                },
                offsetY: 0,
                style: {
                    fontSize: '12px',
                    colors: ["#ffffff"]
                }
            },
            
            xaxis: {
                categories: this.labels,
                position: 'bottom',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    fill: {
                    type: 'gradient',
                    gradient: {
                        colorFrom: '#D8E3F0',
                        colorTo: '#BED1E6',
                        stops: [0, 100],
                        opacityFrom: 0.4,
                        opacityTo: 0.5,
                    }
                    }
                },
                tooltip: {
                    enabled: true,
                }
            },
            yaxis: {
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true
                },
                labels: {
                    show: true,
                    formatter: function (val: any) {
                        return String(val.toFixed(1));
                    }
                }
            },
            title: {
                text: this.name,
                floating: true,
                offsetY: 0,
                align: 'center',
                style: {
                    color: '#444'
                }
            }
        }
    }

    /**
     * onClick
     */
    private onClick(event?: MouseEvent | undefined, activeElements?: {}[] | undefined): any {
    }

    /**
     * Reset chart position
     */
    @Watch('')
    private resetChartPosition() {
    }

    /**
     * click a chart element
     */
    @Emit('click-chart-element')
    public clickChartElement(element: any) {
        return element;
    }

}

